// FavouriteButton.tsx — a heart toggle for any item. Filled when favourited.
// Saves to the shared progress store; favourites appear in the Favourites tab.
import { useProgress } from '@/hooks/useProgress';

export function FavouriteButton({
  stepId,
  size = 20,
  onLight = false,
}: {
  stepId: string;
  size?: number;
  /** Use light styling when placed over a dark image. */
  onLight?: boolean;
}) {
  const progress = useProgress();
  const active = progress.isFavourite(stepId);
  const color = active ? 'var(--amber)' : onLight ? 'rgba(255,248,236,0.92)' : 'var(--ink-soft)';

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        progress.toggleFavourite(stepId);
      }}
      aria-pressed={active}
      aria-label={active ? 'Remove from favourites' : 'Add to favourites'}
      style={{
        width: 44,
        height: 44,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: onLight ? 'rgba(14,10,6,0.32)' : 'transparent',
        backdropFilter: onLight ? 'blur(6px)' : undefined,
        WebkitBackdropFilter: onLight ? 'blur(6px)' : undefined,
        border: 'none',
        borderRadius: 999,
        cursor: 'pointer',
        color,
        transition: 'transform .2s cubic-bezier(.2,.7,.3,1)',
        transform: active ? 'scale(1.06)' : 'scale(1)',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill={active ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ display: 'block' }}
      >
        <path d="M12 19.5C6.5 16 4 12.7 4 9.5A3.8 3.8 0 0 1 12 7a3.8 3.8 0 0 1 8 2.5c0 3.2-2.5 6.5-8 10z" />
      </svg>
    </button>
  );
}
